import React, { useEffect, useState } from 'react';

import { Avatar } from '@mui/material';

import { Popup } from '@/components/Popup/Popup';
import useMediaQuery from '@/hooks/useMediaQuery';
import { ISaveTokenScreenProps } from 'interfaces/UserNftAndToken/userNftToken';

import { PrimaryButton } from '../Button/PrimaryButton';

const SaveTokenScreen = ({
  token,
  lockFile,
  SaveTokenDiv,
  isSaveTokenScreenActive,
  setSaveTokenScreen,
  setSelectTokenScreenActive,
  setTokenAmount,
  tokenAmount,
}: ISaveTokenScreenProps) => {
  const isMediaMax1025px = useMediaQuery('(max-width : 1025px)');
  const [saving, setSaving] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const handleTokenCheck = (tokenObj: any) => {
    const containNumber = (amount: string) => {
      if (typeof amount === 'number') amount = JSON.stringify(amount);
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < amount.length; i++) {
        if (!Number.isNaN(Number(amount))) {
          return true;
        }
      }
      return false;
    };
    const isOnlyZeroDecimal = (amount: string) => {
      if (typeof amount === 'number') amount = JSON.stringify(amount);
      if (Number(amount[0]) > 0 && !amount.includes('.')) {
        return true;
      }
      if (amount[0] === '0') {
        return true;
      }
      return false;
    };
    if (tokenObj.type === 'nft') {
      setIsDisabled(false);
    } else if (
      Number(tokenAmount) !== 0 &&
      containNumber(tokenAmount) &&
      tokenAmount[0] !== '.' &&
      tokenAmount[tokenAmount.length - 1] !== '.' &&
      isOnlyZeroDecimal(tokenAmount)
    ) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  useEffect(() => {
    handleTokenCheck(token);
  }, [tokenAmount]);
  return (
    <Popup
      isOpen={isSaveTokenScreenActive}
      width={isMediaMax1025px ? null : '444px'}
      height={isMediaMax1025px ? null : '75%'}
      margin={isMediaMax1025px ? '70px 5%' : '70px auto'}
      closePopup={() => {}}
    >
      <div ref={SaveTokenDiv} className="p-2">
        <div
          onClick={() => {
            setSaveTokenScreen(false);
            setSelectTokenScreenActive(true);
          }}
        >
          <p className="flex justify-items-start ">Network</p>
          <div className="border mt-2 cursor-pointer rounded-lg border-black w-full p-3">
            <p className="flex justify-items-start ">{`${token.chain[0].toUpperCase()}${token.chain.substring(
              1
            )}`}</p>
          </div>
        </div>
        <div className="mt-4">
          <p className="flex justify-items-start">Token</p>
          <div
            onClick={() => {
              setSaveTokenScreen(false);
              setSelectTokenScreenActive(true);
            }}
            className="border cursor-pointer mt-2 rounded-lg border-black w-full flex p-3"
          >
            <Avatar src={token.image} sx={{ width: 24, height: 24 }} />
            <p className="ml-4 flex justify-center items-center">
              {token.name}
            </p>
          </div>
        </div>
        <div className=" mt-4">
          <p className="flex justify-items-start">Amount</p>
          <div className="border mt-2 rounded-lg border-black w-full p-3">
            <input
              onChange={(e) => {
                if (token.type === 'nft') {
                  const number = Number(e.target.value);
                  if (Number.isNaN(number)) {
                    setTokenAmount((prev: any) => prev);
                  } else {
                    setTokenAmount(number);
                  }
                } else if (
                  /[a-zA-Z]/.test(e.target.value) ||
                  // eslint-disable-next-line no-useless-escape
                  /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/.test(e.target.value)
                ) {
                  setTokenAmount((prev: any) => prev);
                } else {
                  setTokenAmount(e.target.value);
                }
              }}
              className="w-full"
              value={tokenAmount}
            />
          </div>
        </div>
        <div className=" mt-8 flex justify-center">
          <PrimaryButton
            onClick={() => {
              setSaving(true);
              lockFile();
            }}
            disabled={isDisabled}
            isLoading={saving}
          >
            <span>Save</span>
          </PrimaryButton>
        </div>
      </div>
    </Popup>
  );
};

export default SaveTokenScreen;
